import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { selectedTasksSelector } from "./selectedTasksSelector";

export const selectedTasksIdsSelector = createDraftSafeSelector(
  [selectedTasksSelector],
  (tasks) => tasks.map((task) => task.id),
);
